import { useState } from 'react'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { TableBox, Tabs, DropContainer } from "@lk-gtcom/ecomlab-components"
import { LineChart } from '../../charts/LineChart/LineChart'
import "./CrossAnalyticscGeneralIndicators.scss"


const CrossAnalyticscGeneralIndicators = ({
    tableData,
    tableCallback,
    paginatorRef,
    pageValue
}) => {

    return (
        <div className='cross-analyticsc-general-indicators'>
            <TableBox
                {...tableData}
                ref={paginatorRef}
                paginator={pageValue == 'compare_period' ? false : true}
                fetchCallback={tableCallback}
                sortingFunc={tableCallback}
            />
        </div>
    )
}

export { CrossAnalyticscGeneralIndicators }